import React from 'react';
import { parseISO, format, isBefore } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface DateNoticeProps {
  slug?: string;
  isLegacyDimensionPage: boolean;
  meta?: Record<string, any>;
  earlyDate: boolean;
  fromDate: string;
  toDate: string;
  configData?: { contractStartDate?: string };
}

export const DateNotice: React.FC<DateNoticeProps> = ({
  slug,
  isLegacyDimensionPage,
  meta,
  earlyDate,
  fromDate,
  toDate,
  configData,
}) => {
  const { t } = useTranslation();

  const parsedFilterEndDate = parseISO(toDate);
  const parsedLastUpdateDate = meta?.lastUpdatedAt
    ? parseISO(meta.lastUpdatedAt)
    : null;

  const formattedFrom = format(parseISO(fromDate), 'dd MMM, yyyy');
  let formattedTo = format(parsedLastUpdateDate || toDate, 'dd MMM, yyyy');

  // if filter end date is before last updated date, then the end date should be the filter end date
  if (
    parsedLastUpdateDate &&
    isBefore(parsedFilterEndDate, parsedLastUpdateDate)
  ) {
    formattedTo = format(parsedFilterEndDate, 'dd MMM, yyyy');
  }

  const isLegacyDimension =
    slug?.startsWith('dimensions-') && isLegacyDimensionPage && meta;

  if (isLegacyDimension) {
    if (meta.userCount === 0) {
      return <>{t('ORG_DIMS_NO_DATA_NOTICE')}</>;
    }

    const replaced = t('ORG_DIMS_DATE_RANGE_NOTICE').replace(
      /{{ (\w*?) }}/g,
      (_, key: string) => {
        if (key === 'userCount') return meta[key];
        const dateValue = meta?.[key];
        return dateValue && !isNaN(Date.parse(dateValue))
          ? format(parseISO(dateValue), 'dd MMM, yyyy')
          : '';
      },
    );

    return <>{replaced}</>;
  }
  const contractStart = configData?.contractStartDate
    ? format(new Date(configData.contractStartDate), 'dd MMM, yyyy')
    : '';

  if (earlyDate) {
    return (
      <>
        {`Data unavailable from ${formattedFrom} to ${contractStart}. `}
        {t('YOU_ARE_VIEWING_DATA_FROM')} {contractStart} {t('To')} {formattedTo}
      </>
    );
  }

  return (
    <>
      {t('YOU_ARE_VIEWING_DATA_FROM')} {formattedFrom} {t('To')} {formattedTo}
    </>
  );
};
